/* import __COLOCATED_TEMPLATE__ from './objective-list-item-parents.hbs.js'; */
import Component from '@glimmer/component';
import sortableByPosition from 'ilios-common/utils/sortable-by-position';
export default class SessionObjectiveListItemParentsComponent extends Component {
  get parents() {
    return this.args.parents.slice().sort(sortableByPosition).map(t => t.title);
  }
}